import { getConfirmedGroup } from '../confirmed-group'
import { housingResultList } from './housing-result-list'
import {
  CREATE_HOUSINGRESULT_ERROR,
  CREATE_HOUSINGRESULT_SUCCESS,
  DELETE_HOUSINGRESULT_ERROR,
  DELETE_HOUSINGRESULT_SUCCESS,
  LOAD_HOUSINGRESULTS_SUCCESS,
  UNLOAD_HOUSINGRESULTS_SUCCESS,
  UPDATE_HOUSINGRESULT_ERROR,
  UPDATE_HOUSINGRESULT_SUCCESS
} from './action-types';


export function createHousingResultError(error) {
  return {
    type: CREATE_HOUSINGRESULT_ERROR,
    payload: error
  };
}

export function createHousingResultSuccess(housingResult) {
  return {
    type: CREATE_HOUSINGRESULT_SUCCESS,
    payload: housingResult
  };
}

export function deleteHousingResultError(error) {
  return {
    type: DELETE_HOUSINGRESULT_ERROR,
    payload: error
  };
}

export function deleteHousingResultSuccess(housingResult) {
  return {
    type: DELETE_HOUSINGRESULT_SUCCESS,
    payload: housingResult
  };
}

export function updateHousingResultError(error) {
  return {
    type: UPDATE_HOUSINGRESULT_ERROR,
    payload: error
  };
}

export function updateHousingResultSuccess(housingResult) {
  return {
    type: UPDATE_HOUSINGRESULT_SUCCESS,
    payload: housingResult
  };
}

export function loadHousingResultsSuccess(housingResults) {
  return {
    type: LOAD_HOUSINGRESULTS_SUCCESS,
    payload: housingResults
  };
}

export function loadHousingResults(confirmedGroupId) {
  return (dispatch, getState) => {
    housingResultList.path = `housing-assignment`;
    const lookUp = {
      queryChild: "confirmedGroupId",
      queryString: confirmedGroupId,
      lookUpType: "equalTo"
    }
    housingResultList.subscribe(dispatch, lookUp);
  };
}

export function unloadHousingResults() {
  housingResultList.unsubscribe();
  return {
    type: UNLOAD_HOUSINGRESULTS_SUCCESS
  };
}


// WEBPACK FOOTER //
// ./src/core/housing-result/actions.js